import React, { useState, useContext, useEffect } from "react";
import { Button, Input, Typography, Modal, Spin, Switch, Tooltip  } from "antd"; // Import Spin for loading indicator
import { TeamOutlined, PlusOutlined, LoadingOutlined } from "@ant-design/icons"; // Import LoadingOutlined
import { SketchPicker } from "react-color"; // 🎨 Color Picker
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/authContext";
import axios from "axios";
import {unloadUnityWebGL, unityContext} from "../context/unityContext";
import Messages from '../components/Messages';
const { Title, Text } = Typography;

const Groups = ( { onSelect }) => {
  const { currentUser } = useContext(AuthContext);
  const {showMessageError, showMessageWarning, showMessageInfo, showMessageSuccess, messageHolder } = Messages();

  const [isOwner, setIsOwner] = useState(false);
  const [isMember, setIsMember] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [groups, setGroups] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedColor, setSelectedColor] = useState("#FFD700"); // Default yellow color
  const [loading, setLoading] = useState(true); // Loading state
  const navigate = useNavigate();

  /* useEffect(() => {
    const fetchGroups = async () => {
      setLoading(true); // Set loading to true before fetching
      try {
        const response = await axios.get(`/api/groups/owner/${currentUser.id}`);
        setGroups(response.data);
        setIsMember(response.data.length > 0);
      } catch (error) {
        console.error("Error fetching groups:", error);
        message.error("Beim Abrufen der Gruppen ist ein Fehler aufgetreten.");
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };
    fetchGroups();
  }, [currentUser.id]);*/

  useEffect(() => {

    if (unityContext) unloadUnityWebGL();
    const fetchGroups = async () => {
      setLoading(true);
      try {
        let response;
        console.log("currentUser.id:", currentUser);
        if (currentUser.role === 0 ) {
          // Admin fetches owned groups
          setIsOwner(true);
          console.log("admin get group");
          response = await axios.get(`/api/groups/owner/${currentUser.id}`);
        } else if(currentUser){
          // Normal users fetch groups they belong to
          console.log("normal user get group");
          response = await axios.get(`/api/groups/member/${currentUser.id}`);
        }
        setGroups(response.data);
      } catch (error) {
        console.error("Error fetching groups:", error);
        showMessageError("Beim Abrufen der Gruppen ist ein Fehler aufgetreten.");
      } finally {
        setLoading(false);
      }
    };
    if (currentUser && currentUser.id) {
      fetchGroups();
    }
    
  }, [currentUser.id, currentUser.role]);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => {
    setGroupName("");
    setSelectedColor("#FFD700"); // Reset to default color
    setIsModalOpen(false);
  };

  const handleGroupSubmit = async () => {
    if (!groupName.trim()) {
      showMessageError("Bitte trage einen gültigen Gruppennamen ein.");
      return;
    }

    try {
      const response = await axios.post("/api/groups", {
        name: groupName,
        color: selectedColor, // Send the selected color 🎨
        created_at: new Date(),
        owner_id: currentUser.id,
      });

      const newGroup = response.data;

      showMessageSuccess(
        `Die Gruppe "${newGroup.name}" wurde erfolgreich erstellt!`
      );
      setIsMember(true);
      setGroups([...groups, newGroup]);
      setGroupName("");
      setSelectedColor("#FFD700");
      setIsModalOpen(false);
    } catch (error) {
      console.error("Error creating group:", error);
      showMessageError("Beim Erstellen der Gruppe ist ein Fehler aufgetreten.");
    }
  };

  const [canControlDMC, setCanControlDMC] = useState({});

  useEffect(() => {
    const fetchProjectionPermissions = async () => {
      try {
        const response = await axios.get("/api/groups/dmc"); // Fetch all groups
        const permissions = {};
  
        response.data.forEach((group) => {
          permissions[group.id] = group.can_control_dmc === 1; // Ensure it's a boolean
        });
  
        setCanControlDMC(permissions); // Update state with all permissions
      } catch (error) {
        console.error("Error fetching projection permissions:", error);
      }
    };
  
    if (groups.length > 0) {
      fetchProjectionPermissions();
    }
  }, [groups]);

  const handleCanControlDMCToggle = async (groupId, canControl) => {
    try {
      const url = canControl
        ? `/api/groups/${groupId}/grant-dmc`
        : `/api/groups/${groupId}/revoke-dmc`;
  
      await axios.put(url); // Update permission in DB
  
      // Update local state to reflect the change immediately
      setCanControlDMC((prev) => ({
        ...prev,
        [groupId]: canControl,
      }));
  
      showMessageSuccess(
        canControl
          ? "Die Gruppe kann nun die Medien steuern."
          : "Die Gruppe kann die Medien nicht mehr steuern."
      );
    } catch (error) {
      console.error("Error updating projection permission:", error);
      showMessageError("Fehler beim Aktualisieren der Berechtigungen.");
    }
  };


  const handleClick = (group) => {
    if (onSelect) {
      onSelect(group);
    }
  };
  

  return (
    <div style={{ padding: "24px", textAlign: "left" }}>
      {/* Title Section */}
      <Title level={2}>Gruppen</Title>
      <h1>{isOwner}</h1>
      {/* Show "Create Group" button only for admins */}
      {isOwner && (
        <Button
          type="primary"
          size="large" className="btn"
          icon={<PlusOutlined style={{ fontSize: '24px' }}/>}
          onClick={handleOpenModal}
          style={{ marginBottom: "16px" }}
        >
          Neu Gruppe erstellen
        </Button>

      )}

      {loading ? (
       <Spin size="large" className="loader" />
      ) : (
        <>
          {/* No Groups Message */}
          {groups.length === 0 && (
            <div style={{ textAlign: "left", marginTop: "40px" }}>
              <TeamOutlined
                style={{
                  fontSize: "64px",
                  color: "#FFD700",
                  display: "block",
                  marginBottom: "8px",
                }}
              />
              <Text style={{ fontSize: "16px", color: "#666" }}>
                {isOwner
                  ? "Du hast noch keine Gruppe erstellt."
                  : "Du bist noch kein Mitglied einer Gruppe."}
              </Text>
            </div>
          )}

          {/* Groups List */}
          {groups.length > 0 && (
            <div style={{ marginTop: "16px" }}>
              {groups.map((group, index) => (
                <div
                  key={group.id}
                  //onClick={() => navigate(`/group/${group.id}`)}
                  onClick={() => handleClick(group)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#f5f5f5",
                  
                    borderRadius: "8px",
                    marginBottom: "8px",
                    cursor: "pointer",
                    transition: "background 0.3s",
                    border: `1px solid ${group.color || "#ddd"}`, 
                  }}
                >
                  {/* Colored Square with Number */}
                  <div
                    style={{
                      width: "60px",
                      height: "100px",
                      backgroundColor: group.color || "#FFD700",
                      color: "#fff",
                      fontSize: "18px",
                      fontWeight: "bold",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "6px",
                      marginRight: "12px",
                    }}
                  >
                    {index + 1}
                  </div>

                  {/* Group Name */}
                  <Text style={{ fontSize: "16px", fontWeight: "500" }}>
                    {group.name}
                  </Text>

                  {/* Projection Control Toggle (Admins Only) */}
                  {isOwner && (
  <div
    onClick={(e) => e.stopPropagation()} 
    style={{
      marginLeft: "auto",
      display: "flex",
      alignItems: "center",
      gap: "8px",
    }}
  >
   
    <Tooltip title="Erlaubt dieser Gruppe die Mediensteuerung">

      <Switch
      checkedChildren="Mediensteuerung erlaubt" unCheckedChildren="Mediensteuerung deaktiviert"
        checked={canControlDMC[group.id] || false}
        onChange={(checked) => handleCanControlDMCToggle(group.id, checked)}
      />
    </Tooltip>
  </div>
)}
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {/* Modal for Creating Groups (Admins Only) */}
      {isOwner && (
        <Modal
          title="Bitte trage einen Gruppennamen ein"
          open={isModalOpen}
          onCancel={handleCloseModal}
          footer={null}
        >
          <Input
            placeholder="Gruppenname"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            style={{
              border: "2px solid #FFD700",
              borderRadius: "4px",
              marginBottom: "16px",
            }}
          />

          {/* Color Picker */}
          <div style={{ textAlign: "center", marginBottom: "16px" }}>
            <Text>Wähle eine Farbe:</Text>
            <SketchPicker
              color={selectedColor}
              onChangeComplete={(color) => setSelectedColor(color.hex)}
            />
          </div>

          {/* Buttons */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              type="primary"
              onClick={handleGroupSubmit}
              style={{ width: "48%" }}
            >
              Erstellen
            </Button>
            <Button onClick={handleCloseModal} style={{ width: "48%" }}>
              Abbrechen
            </Button>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default Groups;
